<template>
    <!-- 가이드평가 -->
    <v-bottom-sheet
      v-model="sheet"
      scrollable
      persistent
      no-click-animation
      :overlay-opacity="0.7"
      content-class="bottom-sheet"
    >
    <v-card>
        <v-card-title class="justify-space-between">
            <div class="fs-18 fw-500">더 하고 싶은 말이 있으신가요?</div>
            <v-btn icon  @click="$emit('sheetClose')"> <Close /></v-btn>
        </v-card-title>
        <v-card-text  class="sheet-body py-3">
          <div class="fs-16 text-sub-title mb-5" v-if="clientCd != 'samsungfire'">작성해 주시면 추가 코인을 더 드려요!</div>
          <Textarea v-model="comment" :placeholder="`하고 싶은 말을 입력해주세요`" :maxlength="200" :counter="200"/>
        </v-card-text>
        <v-card-actions class="sheet-footer">
           <BlackBtn str="작성완료" :disabled="comment.trim() === ''" @click="$emit('writeComplete', comment)"></BlackBtn>
        </v-card-actions>
    </v-card>
  </v-bottom-sheet>
</template>
<script>
import Close from '@/components/icons/Close';
import BlackBtn from "@/components/btns/BlackBtn";
import Textarea from '@/components/forms/Textarea';
import store from '@/store';
export default {
    props:{
        sheet:Boolean,
    },
    data: () => ({
        comment:'',
        clientCd:'',
    }),
    components:{
        Close,
        Textarea,
        BlackBtn
    },
    methods: {

    },
    created () {
        this.clientCd = store.getters.clientCd
    },
}
</script>
<style lang="scss" scoped>
::v-deep .v-dialog{
  .v-card__title{
    padding-bottom: 0px !important;
  }
  .v-card__text{
    padding-bottom: 0px;
  }
  .v-card__actions{
    padding: 10px 23px 40px;
  }
}
</style>
